import { styled } from 'ui/styles'

export const Page = styled.main`
  flex: 1 0;
  overflow: auto;
  height: 100vh;
`
